import { useContext } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png'
import { MdClose } from "react-icons/md";
import { IoMdArrowDropright } from "react-icons/io";

export default function SideBar(props) {
  const appContext = useContext(AppContext);

  function openSideBar() {
    appContext.setIsSideBarOpen(true);
  }

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });
    if(appContext.isSideBarOpen) closeSideBar();
  }

  const pills = [
    { label: "Home", key: "home" },
    { label: "About Us", key: "about_us" },
    { label: "Services", key: "services" },
    { label: "Contact Us", key: "contact_us" },
    { label: "News & Events", key: "news" },
    { label: "Gallery", key: "gallery" },
  ];

  return (
    <div
      className="SideBar"
      style={{
        position: "fixed",
        top: 0,
        left: appContext.isSideBarOpen ? 0 : "-280px",
        width: "280px",
        height: "100vh",
        background: "linear-gradient(180deg, #0f1115, #1a1c23)",
        color: "#fff",
        transition: "left 0.3s ease",
        zIndex: 1000,
        boxShadow: "4px 0 12px rgba(0,0,0,0.3)",
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll !ipmortant"
      }}
      data-open={appContext.isSideBarOpen}
    >
      <div style={{ padding: "1rem", display: "flex", justifyContent: "flex-end" }}>
        <MdClose 
          size={28}
          style={{ cursor: "pointer", color: "#fff" }}
          onClick={closeSideBar}
        />
      </div>

      <div
        className="logo-holder"
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "2rem",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ width: "100px", height: "auto", objectFit: "contain" }}
        />
      </div>

      <div className="nav-items" style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "0 1rem" }}>
        {pills.map((pill) => (
          <div
            key={pill.key}
            className="pill"
            onClick={() => goTo(pill.key)}
            data-active={appContext.navItem === pill.key || (!appContext.navItem && pill.key === "home")}
            style={{
              padding: "0.75rem 1rem",
              borderRadius: "12px",
              backgroundColor: appContext.navItem === pill.key || (!appContext.navItem && pill.key === "home") ? "#272b38" : "transparent",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#323746"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = appContext.navItem === pill.key || (!appContext.navItem && pill.key === "home") ? "#272b38" : "transparent"}
          >
            <p style={{ margin: 0, fontWeight: 500, fontSize: "1rem" }}>{pill.label}</p>
          </div>
        ))}
        <div
            className="pill"
            onClick={() => goTo("ATRIC-BCL")}
            data-active={appContext.navItem === "ATRIC-BCL"|| (!appContext.navItem && "ATRIC-BCL" === "home")}
            style={{
              padding: "0.75rem 1rem",
              borderRadius: "12px",
              backgroundColor: appContext.navItem === "ATRIC-BCL" || (!appContext.navItem && "ATRIC-BCL" === "home") ? "#272b38" : "transparent",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#323746"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = appContext.navItem === "ATRIC-BCL" || (!appContext.navItem && "ATRIC-BCL" === "home") ? "#272b38" : "transparent"}
          >
            <p style={{ margin: 0, fontWeight: 500, fontSize: "1rem" }}>ATRIC BCL <IoMdArrowDropright /></p>
          </div>
      </div>
    </div>
  )
}
